import { defineMessages } from 'react-intl';

export const i18n: {
	allSites: { id: string; defaultMessage: string; description: string };
	label: { id: string; defaultMessage: string; description: string };
	findSitesPlaceholder: { id: string; defaultMessage: string; description: string };
	selectedHeadingPlain: { id: string; defaultMessage: string; description: string };
	selectedHeadingMax: { id: string; defaultMessage: string; description: string };
	selectedHeadingMaxReached: { id: string; defaultMessage: string; description: string };
	unselectedHeading: { id: string; defaultMessage: string; description: string };
	currentSiteLabel: { id: string; defaultMessage: string; description: string };
} = defineMessages({
	allSites: {
		id: 'search-page.search-page-relay.filters.product-filters.site-select.allSites.ai-non-final',
		defaultMessage: 'All sites',
		description:
			'Label for the default site selection when all available sites fit within the selection limit.',
	},
	label: {
		id: 'search-page.search-page-relay.filters.product-filters.site-select.label',
		defaultMessage: 'Sites',
		description:
			'Fallback label for the site scope selector shown in the full page search filter bar, allowing users to choose which sites to search.',
	},
	findSitesPlaceholder: {
		id: 'search-page.search-page-relay.filters.product-filters.site-select.find-sites-placeholder.ai-non-final',
		defaultMessage: 'Find sites',
		description:
			'Placeholder shown in the site selector search input, prompting users to filter the available sites by name.',
	},
	selectedHeadingPlain: {
		id: 'search-page.search-page-relay.filters.product-filters.site-select.selectedHeadingPlain',
		defaultMessage: 'Selected',
		description:
			'Heading for the group of selected sites when the tenant has fewer sites than the selection cap, so the "select up to" limit is not shown.',
	},
	selectedHeadingMax: {
		id: 'search-page.search-page-relay.filters.product-filters.site-select.selectedHeadingMax',
		defaultMessage: 'Selected <hint>(Select up to {max})</hint>',
		description:
			'Heading for the group of selected sites in the site selector dropdown. {max} is the maximum number of sites that can be selected at once.',
	},
	selectedHeadingMaxReached: {
		id: 'search-page.search-page-relay.filters.product-filters.site-select.selectedHeadingMaxReached',
		defaultMessage: 'Selected <hint>(Maximum selected)</hint>',
		description:
			'Heading for the group of selected sites when the maximum number of sites has already been selected. Communicates that no more sites can be added until one is deselected.',
	},
	unselectedHeading: {
		id: 'search-page.search-page-relay.filters.product-filters.site-select.unselectedHeading',
		defaultMessage: '{count, plural, one {Site} other {Sites}}',
		description:
			'Heading for the group of sites that are not currently selected in the site selector dropdown. Singular "Site" when there is one such site, "Sites" otherwise. {count} is the number of unselected sites. Shown when no collaboration unit or organisation name is available.',
	},
	currentSiteLabel: {
		id: 'search-page.search-page-relay.filters.product-filters.site-select.currentSiteLabel',
		defaultMessage: '{name} <hint>(current)</hint>',
		description:
			'Label for the current/primary site in the site selector. The current site is always selected and cannot be removed. {name} is the site name; the "(current)" suffix is de-emphasised (italic).',
	},
});
